import StoredLayout from '../../layouts/StoredLayout'
import FontAwesome from './FontAwesome'
export default StoredLayout(FontAwesome)



// WEBPACK FOOTER //
// ./src/icons/font-awesome/index.js